var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            disabled: _vm.formReadOnly,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "员工姓名",
                        prop: "user.id",
                        rules: [
                          {
                            required: true,
                            message: "员工姓名不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("user-select", {
                        attrs: { limit: 1, value: _vm.inputForm.user.id },
                        on: {
                          getValue: function (value) {
                            _vm.inputForm.user.id = value
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "报销费用",
                        prop: "cost",
                        rules: [
                          {
                            required: true,
                            message: "报销费用不能为空",
                            trigger: "blur",
                          },
                          {
                            validator: _vm.validator.isFloatGtZero,
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写报销费用" },
                        model: {
                          value: _vm.inputForm.cost,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "cost", $$v)
                          },
                          expression: "inputForm.cost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "归属部门",
                        prop: "office.id",
                        rules: [
                          {
                            required: true,
                            message: "归属部门不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("SelectTree", {
                        ref: "office",
                        attrs: {
                          props: {
                            value: "id", // ID字段名
                            label: "name", // 显示名称
                            children: "children", // 子级字段名
                          },
                          url: "/sys/office/treeData?type=2",
                          value: _vm.inputForm.office.id,
                          clearable: true,
                          accordion: true,
                        },
                        on: {
                          getValue: function (value) {
                            _vm.inputForm.office.id = value
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "报销事由",
                        prop: "reason",
                        rules: [
                          {
                            required: true,
                            message: "报销事由不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请填写报销事由",
                        },
                        model: {
                          value: _vm.inputForm.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "reason", $$v)
                          },
                          expression: "inputForm.reason",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }